import React from 'react';
import { useLanguage } from '../../assets/js/LanguageContext';
import SectionEyebrow from '../common/SectionEyebrow';
import PinnedSteps from '../common/PinnedSteps';
import videoPulse from '../../assets/images/video.mp4';
import '../../assets/styles/SectionBand.css';
import '../../assets/styles/HomeHowItWorks.css';

/* Dos secciones que antes se llamaban casi igual y se pisaban:
 *
 * - "Como funciona" es el recorrido del cliente: pregunta, responden,
 *   analizamos, te llevas datos. Iba en cuatro tarjetas que volteaban, y unas
 *   tarjetas cuentan cuatro cosas sueltas cuando esto es una secuencia. Ahora
 *   son fichas clavadas y unidas por un trazo, que si cuenta el recorrido.
 * - "Como lo hacemos" es lo que hay debajo del capo. Iba con un circulo grande
 *   y el video descolgado al final; ahora la lista y el video van del brazo.
 */

export const HowItWorks = () => {
  const { t } = useLanguage();

  /* Las frases se arman con las claves que ya existian, que estaban partidas
     en trozos para poder pintar cada mitad de un color. */
  const steps = [
    {
      id: 1, accent: '#7C3AED',
      text: `${t('home3_step1_title')} ${t('home3_step1_highlight')}`
    },
    {
      id: 2, accent: '#2563EB',
      text: `${t('home3_step2_title')} ${t('home3_step2_highlight')}`
    },
    {
      id: 3, accent: '#C026D3',
      text: `${t('home3_step3_title')} ${t('home3_step3_subtitle')} ${t('home3_step3_highlight')}`
    },
    {
      id: 4, accent: '#0D9488',
      text: `${t('home3_step4_text')}${t('home3_step4_highlight')}${t('home3_step4_text2')}${t('home3_step4_highlight2')}${t('home3_step4_text3')}`
    }
  ];

  return (
    <section id="funcion" className="section-band">
      <div className="section-band__inner">
        <div className="section-band__head">
          <SectionEyebrow>{t('home3_title')}</SectionEyebrow>
        </div>

        <PinnedSteps steps={steps} />
      </div>
    </section>
  );
};

export const HowWeDoIt = () => {
  const { t } = useLanguage();

  const steps = [
    t('home3_howwedoit_step1'),
    t('home3_howwedoit_step2'),
    t('home3_howwedoit_step3'),
    t('home3_howwedoit_step4'),
    t('home3_howwedoit_step5')
  ];

  return (
    <section className="section-band">
      <div className="section-band__inner">
        <div className="section-band__head">
          <SectionEyebrow>{t('home3_howwedoit_title')}</SectionEyebrow>
        </div>

        <div className="howwedo">
          <ol className="howwedo__list">
            {steps.map((step, index) => (
              <li key={step} className="howwedo__item">
                <span className="howwedo__number">{String(index + 1).padStart(2, '0')}</span>
                <span className="howwedo__text">{step}</span>
              </li>
            ))}
          </ol>

          <div className="howwedo__video">
            <video
              src={videoPulse}
              autoPlay
              muted
              loop
              playsInline
              controls
              className="howwedo__player"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

const Home3 = () => (
  <>
    <HowItWorks />
    <HowWeDoIt />
  </>
);

export default Home3;
